import './bootstrap';

/**
 * Require all files that make up our angular app.
 * This is necessary since they're not split into modules that import each other.
 */
const angularFiles = require.context('./angular', true, /\.tsx?$/);
angularFiles.keys().forEach(angularFiles);

/**
 * Require all the templates for our Angular app.
 */
const templates = require.context('../templates', true, /\.html$/);
templates.keys().forEach(key => {
    // add the content of the html file to angular's template cache.
    angular.module('app').run(['$templateCache', ($templateCache) => {
        $templateCache.put(key.replace('./', ''), templates(key));
    }]);
});

/**
 * Imports React components and makes them available for use inside the angular application.
 */
import './registerAngularComponents';
